import { Injectable, inject } from '@angular/core';
import { HttpService } from '@nha/api/shared';
import { Observable } from 'rxjs';
import { AccountApiConfiguration } from '../account-api-configuration.class';

import { IAccount } from '../types';

@Injectable({
	providedIn: 'root'
})
export class AccountService extends HttpService {
	constructor() {
		const config = inject(AccountApiConfiguration);

		super(config, 'account');
	}

	getByUsername(username: string): Observable<IAccount> {
		const url: string = this.serviceUrl;
		return this.http.get<IAccount>(`${url}/username/${username}`);
	}
}
